import React from 'react';
import { Link } from 'react-router-dom';
import * as Icons from 'lucide-react';
import { SITE, SOCIALS, NAV_LINKS } from '../mock/mock';

const Footer = () => {
  return (
    <footer className="bg-brand-ink text-cream mt-20">
      <div className="max-w-7xl mx-auto px-5 lg:px-8 py-14">
        <div className="grid md:grid-cols-3 gap-10">
          <div>
            <div className="flex items-center gap-3 mb-4">
              <img src={SITE.logo} alt="Limpid Reader" className="h-12 w-12 rounded-full object-cover" />
              <div>
                <div className="font-serif text-xl font-bold">Limpid Reader</div>
                <div className="text-[10px] tracking-luxe text-brand-gold">{SITE.tagline}</div>
              </div>
            </div>
            <p className="text-sm text-white/70 leading-relaxed max-w-xs">
              A digital library and bookstore dedicated exclusively to meaningful non-fiction.
            </p>
          </div>

          <div>
            <h4 className="font-serif text-lg mb-4 text-brand-gold">Explore</h4>
            <ul className="space-y-2">
              {NAV_LINKS.map((l) => (
                <li key={l.path}>
                  <Link to={l.path} className="text-sm text-white/70 hover:text-brand-gold transition-colors">
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-serif text-lg mb-4 text-brand-gold">Connect</h4>
            <p className="text-sm text-white/70 mb-4">
              <a href={`mailto:${SITE.email}`} className="hover:text-brand-gold transition-colors">
                {SITE.email}
              </a>
            </p>
            <div className="flex flex-wrap gap-3">
              {SOCIALS.map((s) => {
                const Ico = Icons[s.icon] || Icons.Link;
                return (
                  <a
                    key={s.name}
                    href={s.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label={s.name}
                    className="h-9 w-9 flex items-center justify-center rounded-full bg-white/10 hover:bg-brand-gold hover:text-brand-ink text-white transition-all duration-300"
                  >
                    <Ico className="h-4 w-4" />
                  </a>
                );
              })}
            </div>
          </div>
        </div>

        <div className="border-t border-white/10 mt-10 pt-6 flex flex-col sm:flex-row justify-between items-center gap-3">
          <p className="text-xs text-white/50">
            © {new Date().getFullYear()} Limpid Reader. All rights reserved.
          </p>
          <p className="text-xs text-white/50 italic font-serif">Read clearly. Think deeply.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
